import React from "react";
import classNames from "classnames";
import { ITreeListItem } from "./Helper/Types";
import { setActiveTab } from "./Helper/Script";
import "./Style.scss";

export interface ITreeListItemProps {
  item: ITreeListItem;
  selected: boolean;
  handleOnClick: (item: ITreeListItem) => void;
  handleOnClickTrailing: (item: ITreeListItem) => void;
}

/**
 * Responsible for render parent report tree view
 */
const TreeListItem: React.FC<ITreeListItemProps> = (props: ITreeListItemProps) => {

  const { item, selected, handleOnClick } = props;
  const classes = classNames(
    "ebt-tree-list__item",
    { "ebt-tree-list__item--active": selected },
    { [`ebt-tree-list__item--${item.level}`]: item.hasNodes }
  );

  /** Renders the relevant extract details in right side
   * on clicking the item
   *
   */
  const onClick = (e: React.SyntheticEvent): void => {
    e.preventDefault();
    handleOnClick(item);
    const availableTabs = document.querySelectorAll(".eui-dynamic-tabs__list-item").length > 2;
    if (availableTabs) {
      setActiveTab(true);
    }
  };

  React.useEffect(() => {
    if (selected) {
      const selectedExtract = document.querySelector(".ebt-tree-list__item--active") as HTMLElement;
      if (selectedExtract) {
        selectedExtract.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
      }
    }
  }, [selected, item]);

  return (
    <>
      <li className={classes} onClick={onClick}>
        <div className="ebt-tree-list__display-text">
          <label data-testid={"ebt-extract-name-" + item.id} className="ebt-tree-list__display-text--label">
            {item.displayText}
          </label>
        </div>
      </li>
    </>
  );
};

export default TreeListItem;
